import React from 'react';
import dot from '../../assets/images/dot.png';
import whiteDot from '../../assets/images/white-dot.png';
import shape1 from '../../assets/images/shape1.svg';
import shape2 from '../../assets/images/shape2.svg';
import shape3 from '../../assets/images/shape3.svg';

const ShapeSet = () => (
    <div className="animation-img">
        <img src={shape1} alt="" aria-hidden="true" />
        <img src={shape2} alt="" aria-hidden="true" />
        <img src={shape3} alt="" aria-hidden="true" />
        <img src={shape1} alt="" aria-hidden="true" />
        <img src={shape2} alt="" aria-hidden="true" />
        <img src={shape3} alt="" aria-hidden="true" />
        <img src={shape1} alt="" aria-hidden="true" />
        <img src={shape3} alt="" aria-hidden="true" />
    </div>
);

const DotSet = () => (
    <div className="dot-img">
        <img src={dot} alt="" aria-hidden="true" className="color-dot" />
        <img src={whiteDot} alt="" aria-hidden="true" className="white-dot" />
    </div>
);

class FeaturesTwo extends React.Component {
    render(){
        return (
            <section className="uk-features features-area uk-section uk-padding-remove-top">
                <div className="uk-container">
                    <div className="uk-grid uk-grid-match uk-grid-medium uk-child-width-1-3@m">
                        <div className="uk-item">
                            <div className="single-features-box">
                                <div className="icon">
                                    <i className="flaticon-think"></i>
                                </div>
                                <h3>AI & Machine Learning</h3>
                                <div className="bar"></div>
                                <p>Custom ML models, LLM integrations, and intelligent automation that make your products smarter and your operations faster.</p>
                                <DotSet />
                                <ShapeSet />
                            </div>
                        </div>

                        <div className="uk-item">
                            <div className="single-features-box active">
                                <div className="icon">
                                    <i className="flaticon-plan"></i>
                                </div>
                                <h3>Custom Software Development</h3>
                                <div className="bar"></div>
                                <p>Scalable web and mobile applications built with modern frameworks, designed to grow with your business from day one.</p>
                                <DotSet />
                                <ShapeSet />
                            </div>
                        </div>

                        <div className="uk-item">
                            <div className="single-features-box">
                                <div className="icon">
                                    <i className="flaticon-analytics-1"></i>
                                </div>
                                <h3>Cloud & DevOps</h3>
                                <div className="bar"></div>
                                <p>AWS, Azure, and GCP infrastructure, CI/CD pipelines, and containerised deployments that keep your services reliable and fast.</p>
                                <DotSet />
                                <ShapeSet />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default FeaturesTwo;
